import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { HttpEventType, HttpEvent } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { SubItemCheckedDTO } from '../model/subItem-checked-dto';
import { SubItem } from '../model/sub-item';

@Injectable({
    providedIn: 'root'
  })
  export class GestionFichierService{

    constructor(private http: HttpClient, private _restClientService : RestClientService) 
    {}

    getPiecesClient(requestId) 
    {
        return this._restClientService.load<SubItemCheckedDTO[]>('gestion-fichier/pieces-client?requestid='+requestId);
    }
    getDocumentsByGarantieId(requestId, garantieId) 
    {
        return this._restClientService.load<SubItem[]>('gestion-fichier/garanties-client?requestid='+requestId+'&garantieId='+garantieId);
    }

    getDocumentGaranties(requestId) 
    {
        return this._restClientService.load<SubItem[]>('gestion-fichier/garanties-client?requestid='+requestId);
    }

    
    getRapportsClient(requestId, search) 
    {
        return this._restClientService.load<SubItemCheckedDTO[]>('gestion-fichier/rapports-client?requestid='+requestId+'&search='+search);
    }

    remplacer(
      file:File,
      filename,
      displayname,
      checked,
      commentaire,
      subItemId
      ) 
      {
        let url: string = environment.BACKEND_RACINE_URL+"gestion-fichier/remplacer-fichier";

        var fd = new FormData();
        fd.append("file", file, file.name);
        fd.set("filename", filename);
        fd.set("displayname", displayname);
        fd.set("checked", checked);
        fd.set("commentaire", commentaire);
        fd.set("subItemId", subItemId);

        var reqHeader = new HttpHeaders({
        });

        return this.http.post<any>(url, fd, { headers: reqHeader }).pipe(map(fichier => {
        return fichier;
        }));

    }

    rename(renameFile) {
      return  this._restClientService.put<any>(`gestion-fichier/renommer-fichier`, renameFile);
    }
    
    delete(id) 
    {
      return this._restClientService.delete<any>('gestion-fichier/supprimer-fichier/'+id);
    }
  
    uploadInPiece(
        file:File,
        filename,
        displayname,
        checked,
        commentaire,
        requestId
        ) 
        {
          let url: string = environment.BACKEND_RACINE_URL+"gestion-fichier/upload-in-piece";

          var fd = new FormData();
          fd.append("file", file, file.name);
          fd.set("filename", filename);
          fd.set("displayname", displayname);
          fd.set("checked", checked);
          fd.set("commentaire", commentaire);
          fd.set("requestId", requestId);

          var reqHeader = new HttpHeaders({
          });

          return this.http.post<any>(url, fd, { headers: reqHeader }).pipe(map(fichier => {
          return fichier;
          }));

    }

    uploadInDocumentGarantie(
      file:File,
      codeDocument,
      displayname,
      checked,
      commentaire,
      requestId,
      garantieId
      ) 
      {
        let url: string = environment.BACKEND_RACINE_URL+"gestion-fichier/upload-in-garantie";

        var fd = new FormData();
        fd.append("file", file, file.name);
        fd.set("codeDocument", codeDocument);
        fd.set("displayname", displayname);
        fd.set("checked", checked);
        fd.set("commentaire", commentaire);
        fd.set("requestId", requestId);
        fd.set("garantieId", garantieId);

        var reqHeader = new HttpHeaders({
        });

        return this.http.post<any>(url, fd, { headers: reqHeader }).pipe(map(fichier => {
        return fichier;
        }));

  }
    uploadInRapport(
      file:File,
      filename,
      displayname,
      checked,
      commentaire,
      requestId
      ) 
      {
        let url: string = environment.BACKEND_RACINE_URL+"gestion-fichier/upload-in-rapport";

        var fd = new FormData();
        fd.append("file", file, file.name);
        fd.set("filename", filename);
        fd.set("displayname", displayname);
        fd.set("checked", checked);
        fd.set("commentaire", commentaire);
        fd.set("requestId", requestId);

        var reqHeader = new HttpHeaders({
        });

        return this.http.post<any>(url, fd, { headers: reqHeader }).pipe(map(fichier => {
        return fichier;
        }));

    }


    downloadFile(subitemId: string): Observable<Blob> {
        
      const downloadUrl = environment.BACKEND_RACINE_URL+`gestion-fichier/download?subitemid=${subitemId}`;

      const options = {
        responseType: 'blob' as 'json',
      };
      
      return this.http.get<any>(downloadUrl, options);
    }

    
    downloadFileProgress(subitemId: string): Observable<{ progress: number, blob?: Blob }> {
      const req = new HttpRequest('GET', environment.BACKEND_RACINE_URL+`gestion-fichier/download?subitemid=${subitemId}`, {
        reportProgress: true,
        responseType: 'blob'
      });
  
      return this.http.request(req).pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.DownloadProgress:
              const total = event.total || event.loaded; // Fallback to event.loaded if total is unavailable
              const progress = Math.round((100 * event.loaded) / total);
              console.log(`Downloaded: ${event.loaded} / ${event.total} (${progress}%)`);
              return { progress };
            case HttpEventType.Response:
              return { progress: 100, blob: event.body };
            default:
              return { progress: 0 };
          }
        })
      );
    }
  
    
    downloadBase64(subitemId: string) 
    {
      const downloadUrl = environment.BACKEND_RACINE_URL+`gestion-fichier/download-base64?subitemid=${subitemId}`;

      const options = {
        responseType: 'text' as 'json',
      };
      
      return this.http.get<any>(downloadUrl, options);
    }

    
    downloadAllFile(requestId: string): Observable<Blob> {
        
      const downloadUrl = environment.BACKEND_RACINE_URL+`gestion-fichier/download-all?requestid=${requestId}`;

      const options = {
        responseType: 'blob' as 'json',
      };
      
      return this.http.get<any>(downloadUrl, options);
    }

    
    downloadAllFileProgress(requestId: string): Observable<{ progress: number, blob?: Blob }> {
      const req = new HttpRequest('GET', environment.BACKEND_RACINE_URL+`gestion-fichier/download-all?requestid=${requestId}`, {
        reportProgress: true,
        responseType: 'blob'
      });
  
      return this.http.request(req).pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.DownloadProgress:
            const progress = Math.round((100 * event.loaded) / (event.total || 1));
              return { progress };
            case HttpEventType.Response:
              return { progress: 100, blob: event.body };
            default:
              return { progress: 0 };
          }
        })
      );
    }
  

    
}      

    